import React, { useEffect, useState } from "react";

const Career = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });

  const [number, setNumber] = useState();

  // Function to handle number input validation
  const handleNumberInput = (event) => {
    // Get the input value
    let value = event.target.value;

    // Remove non-digit characters
    let digitValue = value.replace(/\D/g, "");

    // Limit the length to 10 characters
    digitValue = digitValue.slice(0, 10);

    // Update the state
    setNumber(digitValue);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Validate each field as it is changed
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let errorMessage = "";

    switch (name) {
      case "name":
        errorMessage = value.trim()
          ? value.length === 10
            ? ""
            : "Name must be 15 letters"
          : "Name is required";
        break;
      case "email":
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        errorMessage =
          value.trim() && emailRegex.test(value)
            ? ""
            : "Valid email is required";
        break;
      case "number":
        const numberRegex = /^\d{10}$/; // 10 digits
        errorMessage =
          value.trim() && numberRegex.test(value)
            ? ""
            : "Number must be 10 digits";
        break;
      case "message":
        errorMessage = value.trim() ? "" : "Message is required";
        break;
      default:
        break;
    }

    setErrors({
      ...errors,
      [name]: errorMessage,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    const isValid = Object.values(errors).every((error) => error === "");

    if (isValid) {
      // Perform the form submission logic (e.g., display success message)
      console.log("Form submitted:", formData);
    } else {
      console.log("Form validation failed");
    }
  };

  return (
    <div>
      <div
        className="container-fluid bg-primary bg-quote1 py-5"
        id="career"
        style={{ margin: "90px 0" }}
      >
        <div className="container py-5">
          <div className="row g-0 justify-content-start">
            <div className="col-lg-6">
              <div className="bg-white text-center p-5">
                <h1 className="mb-4">Upload Your CV</h1>
                <form action="https://formspree.io/f/xrgwnkae" method="POST">
                  <div className="row g-3">
                    <div className="col-12 col-sm-6">
                      <input
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        type="text"
                        className="form-control bg-light border-0"
                        placeholder="Contact Name"
                        style={{ height: 55 }}
                        maxlength="30"
                        required
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control bg-light border-0"
                        placeholder="E-mail"
                        style={{ height: 55 }}
                        maxlength="30"
                        required
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <input
                        type="text"
                        id="numberInput"
                        name="number"
                        value={number}
                        onChange={handleNumberInput}
                        className="form-control bg-light border-0"
                        placeholder="Contact Number"
                        style={{ height: 55 }}
                        maxlength="10"
                        pattern="[0-9]{10}"
                        required
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <input
                        type="address"
                        name="address"
                        className="form-control bg-light border-0"
                        placeholder="Job prefer"
                        style={{ height: 55 }}
                        maxlength="45"
                      />
                    </div>
                    <div className="col-12">
                      <label
                        for=""
                        style={{
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        Add your CV
                      </label>
                      <input
                        type="file"
                        className="form-control bg-light border-0"
                        placeholder="Your CV"
                        style={{ height: 55 }}
                        name="file"
                        accept=".pdf"
                      />
                    </div>
                    <div className="col-12">
                      <textarea
                        className="form-control bg-light border-0 py-3"
                        rows={2}
                        placeholder="Position Requested/ Work experience "
                        defaultValue={""}
                        name="message"
                        maxlength="150"
                      />
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-primary w-100 py-3"
                        type="submit"
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Career;
